import {
    StatusCodes as httpStatus,
} from 'http-status-codes';
import { BACK_ORDER_DEAL_AVAILABILITY_STATUS } from "../config/constants";

export class CustomError extends Error {
    constructor(message, status, data, cause) {
        super(message);
        this.name = this.constructor.name;
        this.status = status;
        this.data = data;
        this.cause = cause;

        if (Error.captureStackTrace !== undefined) {
            Error.captureStackTrace(this, this.constructor);
        }
    }
}

export const handleMagentoResponse = (res) => {
    let ok_value = true;
    let status_value = httpStatus.OK;
    let msg = 'success';

    if (!res || !res.data || (!res.data && !res.errors)) {
        const err = new CustomError(
            'InvalidResponse',
            httpStatus.FAILED_DEPENDENCY,
            res
        );

        return {
            ok: false,
            error: err,
            message: err,
            data: res.data,
            response_time: res.response_time
        };
    }

    if (res?.errors) {
        let err_msg = res?.errors?.[0]?.message;

        if (err_msg.includes("cannot perform operations on cart") || 
            err_msg.includes("Could not find a cart") || 
            err_msg.includes("Cannot query field")) {
            status_value = httpStatus.UNPROCESSABLE_ENTITY;
        }
        else if (err_msg.includes("Some of the products are out of stock") ||
                err_msg.includes("There are no source items with the in stock status") && res.data) {
            // make it success response
            return {
                ok: ok_value,
                status: httpStatus.OK,
                data: res.data,
            };
        } else if (err_msg.includes("Product that you are trying to add is not available")) {
            status_value = BACK_ORDER_DEAL_AVAILABILITY_STATUS;
        } else {
            status_value = httpStatus.INTERNAL_SERVER_ERROR;
        }

        ok_value = false;
        msg = new CustomError('MagentoError', status_value, res);

        return {
            ok: ok_value,
            status: status_value,
            data: res.data,
            message: msg,
            errors: res?.errors
        };
    }

    return {
        ok: ok_value,
        status: status_value,
        data: res.data,
    };

};